import { z } from "zod";
import {
  directoryRoleSchema,
  employmentTypeSchema,
  membershipChannelSchema,
  workModeSchema,
} from "@/shared/membership/directory.schema";

const bulkRowResultSchema = z.object({
  membershipId: z.string().optional(),
  invitationId: z.string().optional(),
  ok: z.boolean(),
  reason: z.string().optional(),
  code: z.string().optional(),
});

export const bulkActionResultSchema = z.object({
  attempted: z.number().int(),
  succeeded: z.number().int(),
  skipped: z.number().int(),
  errors: z.number().int(),
  rowResults: z.array(bulkRowResultSchema),
});
export type BulkActionResult = z.infer<typeof bulkActionResultSchema>;

export const bulkEditHrChangesSchema = z
  .object({
    title: z.string().max(120).optional(),
    departmentId: z.string().max(60).optional(),
    hireDate: z.string().optional(),
    employmentType: employmentTypeSchema.optional(),
    workMode: workModeSchema.optional(),
    location: z.string().max(120).optional(),
  })
  .strict();
export type BulkEditHrChanges = z.infer<typeof bulkEditHrChangesSchema>;

export const bulkEditHrInputSchema = z.object({
  membershipIds: z.array(z.string()).min(1).max(500),
  changes: bulkEditHrChangesSchema,
});

export const bulkAssignManagerInputSchema = z.object({
  membershipIds: z.array(z.string()).min(1).max(500),
  newManagerMembershipId: z.string().optional(),
  unassign: z.boolean().optional(),
  /** Retry flag: promote the chosen manager out of `member` before assigning. */
  promoteManagerRole: z.literal(true).optional(),
});
export type BulkAssignManagerInput = z.infer<typeof bulkAssignManagerInputSchema>;

export const bulkChangeRoleInputSchema = z.object({
  membershipIds: z.array(z.string()).min(1).max(500),
  role: directoryRoleSchema,
});

export const bulkRemoveInputSchema = z.object({
  membershipIds: z.array(z.string()).min(1).max(500),
});

export const bulkInvitationActionInputSchema = z.object({
  invitationIds: z.array(z.string()).min(1).max(500),
});

export const managerBulkPrefsChangesSchema = z
  .object({
    channel: membershipChannelSchema.optional(),
    isPulseActive: z.boolean().optional(),
  })
  .strict();
export type ManagerBulkPrefsChanges = z.infer<typeof managerBulkPrefsChangesSchema>;

export const managerBulkEditPrefsInputSchema = z.object({
  membershipIds: z.array(z.string()).min(1).max(500),
  changes: managerBulkPrefsChangesSchema,
  includeIndirect: z.boolean().optional(),
});
